'use client';

import React, { useEffect } from 'react';
import Hero, { HeroProps } from 'components/commercetools-ui/organisms/content/hero';
import { TasticProps } from 'frontastic/tastics/types';
import { useAccount } from 'frontastic/hooks';
import useLocale from 'helpers/hooks/useLocale';
import { DataLayerOnLoad } from 'helpers/dataLayerHelpers';

const HeroTastic = ({ data }: TasticProps<HeroProps>) => {
  const { getCountry, getCurrency } = useLocale();
  const { account } = useAccount();

  useEffect(() => {
    const localeData = {
      country: getCountry(),
      currency: getCurrency(),
    };

    const currentUrl = document.location.origin;
    const dataLayer = new DataLayerOnLoad(currentUrl, 'home', localeData, account);
    dataLayer.setDataLayerOnLoad();
  }, []);
  return (
    <Hero
      image={data.image}
      title={data.title}
      subtitle={data.subtitle}
      ctaLabel={data.ctaLabel}
      ctaReference={data.ctaReference}
    />
  );
};

export default HeroTastic;
